import { colors } from 'Constants/Colors';

/**
 * Tokens de diseño de la interfaz.
 *
 * Centralizan color, radios y sombras en un solo punto para que cualquier
 * ajuste de marca se propague a todos los primitivos sin tocarlos uno por uno.
 * El acento principal se ata al verde de marca (`colors.GREEN`) para que la
 * pantalla no se sienta ajena al resto de la plataforma.
 */
export const uiTheme = {
  color: {
    primary: colors.GREEN,
    surface: colors.WHITE,
    border: '#e9ecf0',
    borderHover: '#cdd3da',
    title: '#2f3337',
    text: '#5a6066',
    muted: '#8a9099',
    disabled: '#aab0b6',
    countBg: '#eef9f1',
    countText: '#16a34a',
    // Escala de grises para el estado deshabilitado ("Próximamente").
    disabledSurface: '#f5f6f8',
    disabledBorder: '#e4e7eb',
    disabledIconBg: '#eceef1',
    disabledIcon: '#b4bbc2',
    disabledTitle: '#9aa0a6',
    disabledText: '#b4bbc2',
    // Acción primaria (verde de marca) y destructiva.
    primaryHover: '#007a3b',
    danger: '#e8453c',
    dangerHover: '#cf3a32',
    dangerSurface: '#fdeceb',
    // Formularios y controles.
    inputBorder: '#d8dde2',
    searchBorder: '#e0e4e8',
    inputBg: colors.WHITE,
    // Rediseño de las pantallas de definición (variación 1c).
    pageBg: '#f7f8fa',
    titleStrong: '#1c1f24',
    dropBorder: '#b9c0c9',
    accentSoft: '#eaf8f0',
    // Estatus Vencido: ámbar, para no confundirlo con Reprobado (rojo).
    expiredBg: '#b7791f',
    expiredText: '#1c1f24',
    segmentTrack: '#eef1f4',
    segmentActiveText: '#16a34a',
    // Tabla.
    tableHeadBg: '#fafbfc',
    tableHeadText: '#9aa0a6',
    rowBorder: '#f1f3f6',
    rowHoverBg: '#fafbfc',
    // Insignia de tipo (interno / externo).
    typeExternalBg: '#e7f6ee',
    typeExternalText: '#15803d',
    typeInternalBg: '#eef1f4',
    typeInternalText: '#5a6066',
    // Indicador de estatus (activo / inactivo).
    statusActive: '#16b45a',
    statusActiveText: '#15803d',
    statusInactive: '#b4bbc2',
    statusInactiveText: '#9aa0a6',
  },
  radius: {
    xs: '8px',
    sm: '9px',
    button: '10px',
    md: '13px',
    lg: '14px',
  },
  /**
   * Puntos de quiebre. El repo los tenía sueltos —SectionGrid usa 1100 y 720
   * en línea, otras pantallas 465, 800 y 1024— y cada pantalla elegía el suyo.
   * Lo nuevo usa estos; lo viejo se migra cuando se toque.
   */
  breakpoint: {
    sm: '600px',
    md: '900px',
    lg: '1200px',
  },
  shadow: {
    card: '0 1px 2px rgba(16, 24, 40, 0.04)',
    cardHover: '0 8px 22px rgba(16, 24, 40, 0.09)',
  },
  // La fuente se define una sola vez en GlobalStyle (--app-font).
  font: 'var(--app-font)',
} as const;

export default uiTheme;
